import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { AspectRatio } from '@yme/utils/constants';
export const ImageContainerStyled = styled.div `
  width: 86px;
  height: 48px;

  ${ADAPTIVE.maxWidth.tablet} {
    width: 64px;
    height: 37px;
  }

  aspect-ratio: ${AspectRatio.RectangleLevel3};
`;
